import React from "react";
import Paper from "@mui/material/Paper";
import appContext from "../../appContext";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import PublishIcon from "@mui/icons-material/Publish";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import { makeStyles } from "@mui/styles";
import { globalColors } from "../../Utils/colors";
import { sidebarValueConstants } from "./sidebarutils";

const useStyles = makeStyles(() => ({
  root: {
    alignItems: "center",
    bottom: 0,
    display: "flex",
    gap: 10,
    height: 56,
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
  },
}));

const FooterButton = ({
  clickHandler,
  hasDisabled,
  isViewable,
  iconColor,
  iconRenderer,
  tooltipHeader,
}: any) => {
  return isViewable ? (
    <Tooltip title={tooltipHeader}>
      <IconButton
        disabled={hasDisabled}
        onClick={clickHandler}
        sx={{ "&:hover": { color: iconColor } }}
      >
        {iconRenderer()}
      </IconButton>
    </Tooltip>
  ) : (
    <React.Fragment />
  );
};

export default function GlobalFooter({
  isOpen,
  multiDeleteArr,
  openDeleteConfirmPopup,
  handleCancel,
  handlepublishForm,
  handleMoveToDraft,
}: any) {
  const classes = useStyles();
  const { selectedMode } = React.useContext(appContext);

  const viewableOptions = React.useMemo(() => {
    const hasSelection = Boolean(multiDeleteArr.length);

    return [
      {
        id: "delete",
        clickHandler: openDeleteConfirmPopup,
        iconColor: globalColors.iconColors.delete,
        iconRenderer: () => {
          return <DeleteIcon />;
        },
        isViewable: true,
        hasDisabled: !hasSelection,
        tooltipHeader: "Delete selected",
      },
      {
        id: "draft",
        clickHandler: handleMoveToDraft,
        iconColor: globalColors.iconColors.moveToDraft,
        iconRenderer: () => {
          return <DriveFileMoveIcon />;
        },
        isViewable: selectedMode !== sidebarValueConstants.drafted,
        hasDisabled: !hasSelection,
        tooltipHeader: "Move to draft",
      },
      {
        id: "publish",
        clickHandler: handlepublishForm,
        iconColor: globalColors.iconColors.publish,
        iconRenderer: () => {
          return <PublishIcon />;
        },
        isViewable: selectedMode === sidebarValueConstants.drafted,
        hasDisabled: !hasSelection,
        tooltipHeader: "Publish",
      },
      {
        id: "clear",
        clickHandler: handleCancel,
        iconColor: globalColors.iconColors.clear,
        iconRenderer: () => {
          return <ClearIcon />;
        },
        isViewable: true,
        hasDisabled: false,
        tooltipHeader: "Clear",
      },
    ];
  }, [
    selectedMode,
    multiDeleteArr,
    openDeleteConfirmPopup,
    handleCancel,
    handleMoveToDraft,
    handlepublishForm,
  ]);

  if (isOpen) {
    return (
      <Paper className={classes.root} elevation={3}>
        {viewableOptions.map(
          ({
            clickHandler,
            iconColor,
            iconRenderer,
            isViewable,
            hasDisabled,
            tooltipHeader,
          }) => {
            return (
              <FooterButton
                clickHandler={clickHandler}
                iconColor={iconColor}
                iconRenderer={iconRenderer}
                isViewable={isViewable}
                hasDisabled={hasDisabled}
                tooltipHeader={tooltipHeader}
              />
            );
          }
        )}
      </Paper>
    );
  }

  return <React.Fragment />;
}
